export const faqData = [
  {
    question: '奇优影院真的完全免费吗？',
    answer: '是的，奇优影院对所有用户完全免费。我们承诺不收取任何会员费、点播费或隐藏费用。您可以在奇优影院免费观看所有电影、电视剧、综艺节目和纪录片，无需注册即可享受高清流畅的观影体验。',
  },
  {
    question: '为什么有些影片需要缓冲？',
    answer: '影片播放的流畅度主要取决于您的网络环境。建议使用WiFi或5G网络观看，最低带宽要求为5Mbps。如果您遇到缓冲问题，可以尝试切换网络、降低画质设置或避开网络使用高峰期观看。',
  },
  {
    question: '奇优影院的影片资源更新频率如何？',
    answer: '奇优影院的内容团队每天都会更新最新的影视资源。热门电影通常在院线下映后1-2个月内上线，热门电视剧和综艺节目一般在播出后24小时内更新。您可以关注网站首页的"最新上线"板块获取最新内容。',
  },
  {
    question: '可以在电视上观看奇优影院吗？',
    answer: '可以。奇优影院支持DLNA和AirPlay投屏协议。只需确保您的手机或电脑与电视连接同一WiFi网络，点击播放器右上角的投屏图标，即可将画面投射到电视大屏幕上观看。',
  },
  {
    question: '影片的画质可以达到什么水平？',
    answer: '奇优影院提供标清（480P）、高清（720P）和超清（1080P）三种画质选择。大部分热门影片均支持1080P超清画质播放。您可以在播放器右下角手动切换画质，系统也会根据您的网络状况自动推荐最佳画质。',
  },
  {
    question: '如何搜索我想看的影片？',
    answer: '您可以通过网站顶部的搜索框输入影片名称、导演或演员姓名进行搜索。此外，我们还提供了按类型、地区、年代等多种分类浏览方式，帮助您快速找到感兴趣的影片。',
  },
  {
    question: '奇优影院支持哪些设备？',
    answer: '奇优影院采用响应式网页设计，完美适配电脑、平板、手机等多种设备。无论您使用Windows、macOS、iOS还是Android系统，都可以通过浏览器直接访问奇优影院，无需下载任何APP。',
  },
];

export const aboutInfo = {
  brandName: '奇优影院',
  slogan: '免费观影，品质不将就',
  intro: '奇优影院成立于2020年，是国内领先的免费在线影视播放平台。我们致力于为广大影视爱好者提供最新、最全、最高清的电影、电视剧、综艺、动漫和纪录片资源，让每一位用户都能畅享极致的观影体验。',
  mission: '让优质影视内容触手可及，打破付费壁垒，实现全民免费观影。',
  vision: '成为华语地区最受欢迎、最值得信赖的免费在线影视平台。',
  values: [
    { title: '用户至上', desc: '始终把用户体验放在第一位，不断优化产品和服务。' },
    { title: '内容为王', desc: '持续更新高质量影视资源，满足多元化的观影需求。' },
    { title: '技术驱动', desc: '运用先进技术保障播放流畅度和画质体验。' },
    { title: '免费初心', desc: '坚持免费模式，让更多人享受优质影视内容。' },
  ],
  milestones: [
    { year: '2020', event: '奇优影院正式上线，推出首批1000+影视资源' },
    { year: '2021', event: '用户突破100万，完成首次产品重大升级' },
    { year: '2022', event: '上线4K超清专区，影视资源库突破10000+' },
    { year: '2023', event: '用户突破500万，推出个性化推荐系统' },
    { year: '2024', event: '全面升级播放器技术，支持多端投屏和离线缓存' },
    { year: '2025', event: '用户突破1000万，成为华语区领先的免费影视平台' },
  ],
  contact: {
    email: 'contact@qiyoucinema.com',
    wechat: '奇优影院',
    weibo: '@奇优影院官方',
    address: '北京市朝阳区望京科技园A座',
    phone: '400-888-9999',
  },
};